import { COLORS } from 'constants/colors'
import styled from 'styled-components'

export const EmailText = styled.span`
  color: ${COLORS.text.default};
`
